// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import "./assets/scss/index.scss";

import Router from './Router'

createRoot(document.getElementById('root')).render(<Router />)
